import React from "react";
import { Box, Typography, Icon, keyframes } from "@mui/material";
import { useTheme } from "@emotion/react";
import cityscapeSvg from "../../assets/svg/city-scape3.svg";

// Seamless horizontal scrolling animation for cityscape
const cityScroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-25%);
  }
`;

const GivingBackIcon = ({ variant = "light" }) => {
  const theme = useTheme();
  const { primary, overlay } = theme.palette;
  const isDark = variant === "dark";

  // Colors based on variant
  const backgroundColor = isDark ? overlay.black30 : overlay.black40;
  const edgeLineColor = overlay.white30;

  return (
    <Box
      sx={{
        position: "relative",
        width: "200px",
        height: "100%",
        margin: "0 auto",
        backgroundColor: backgroundColor,
        backdropFilter: "blur(10px)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Left edge line */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "1px",
          backgroundColor: edgeLineColor,
        }}
      />

      {/* Right edge line */}
      <Box
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: "1px",
          backgroundColor: edgeLineColor,
        }}
      />

      {/* Animated cityscape background container */}
      <Box
        sx={{
          position: "absolute",
          bottom: "-20px",
          left: 0,
          width: "100%",
          height: "125%",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            height: "100%",
            display: "flex",
            animation: `${cityScroll} 30s linear infinite`,
            willChange: "transform",
            filter: isDark ? "invert(1) brightness(0.9)" : "none",
          }}
        >
          {/* Multiple cityscape copies to ensure no gaps */}
          {[...Array(4)].map((_, index) => (
            <img
              key={index}
              src={cityscapeSvg}
              alt="cityscape"
              style={{
                height: "100%",
                width: "auto",
                display: "block",
                objectFit: "contain",
                objectPosition: "bottom",
                verticalAlign: "bottom",
                marginLeft: index === 0 ? 0 : "-1px",
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default GivingBackIcon;
